import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { questionsApi } from '@/services/questions';
import { QuestionDetailContent, buildIncludedIndex } from '@/components/custom/question/question-detail-content';

export default function ViewQuestionModal(props) {
  const { show, onClose, question } = props;
  const [detail, setDetail] = useState(null);
  const [included, setIncluded] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !question?.id) {
      return;
    }

    setLoading(true);
    questionsApi
      .show(question.id)
      .then(json => {
        setDetail(json?.data || null);
        setIncluded(buildIncludedIndex(json?.included || []));
      })
      .catch(() => {
        setDetail(null);
        setIncluded({});
      })
      .finally(() => setLoading(false));
  }, [show, question?.id]);

  return (
    <Dialog
      open={show}
      onOpenChange={onClose}
    >
      <DialogContent
        size="md"
        layout="flex"
        className="max-h-[85vh] gap-0 overflow-hidden p-0"
      >
        <QuestionDetailContent
          question={detail}
          included={included}
          loading={loading}
        />
      </DialogContent>
    </Dialog>
  );
}
